import { Injectable } from '@angular/core';
import { addHandler, updatedChannelEvent } from '../models/events';
import { ColorDeciderService } from './color-decider.service';
import { ColorAnimationService } from './color-animation.service';

@Injectable({ providedIn: 'root' })
export class PumpService {
    constructor(
        private colorDeciderService: ColorDeciderService,
        private colorAnimationService: ColorAnimationService
    ) {}

    addDefaultPumpListener(elem: Element, elementSetting: any) {
        if (!elementSetting.channelTag) return;

        const boundingCircle = elem.querySelector(':scope > circle:not(.pump-center-circle)');
        if (!boundingCircle) return;

        const circleId = boundingCircle.getAttribute('id');
        const defaultCircleFill = boundingCircle.getAttribute('fill');
        const statusPaths = elem.querySelectorAll('path.pump-body, path.pump-color');

        const handler = async (event: CustomEvent) => {
            const statusColor = this.colorDeciderService.getMotorChannelColor(event.detail.value);
            statusPaths.forEach(path => path.setAttribute('fill', statusColor));

            const elementClasses = this.colorAnimationService.getClassesByFlag(event.detail);
            if (this.colorAnimationService.hasFlagStatus(elementClasses)) {
                this.colorDeciderService.setAlarmFlagsColor(elementClasses, boundingCircle);
                return;
            }

            this.colorDeciderService.stopAlarmFlagsColor(circleId);
            this.colorDeciderService.currentFills.delete(circleId);
            boundingCircle.setAttribute('fill', defaultCircleFill);
        };
        addHandler(elem, updatedChannelEvent, handler);
    }
}
